import React from "react";
import mercados_mayoristas from "../assets/mayoristas.png";
import {
  COLORS_ZONIFICACION,
  COLORS_LOTES,
  COLORS_LOTES_PARQUES,
  COLORS_MERCADOS,
} from "../utils/styleUtils";
import LayersIcon from "@mui/icons-material/LayersOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const toTitleCase = (s) =>
  String(s || "")
    .toLowerCase()
    .replace(/(^|\s)\S/g, (t) => t.toUpperCase());

const shapeClass = (icon) => {
  if (icon === "rombo") return "is-rombo";
  if (icon === "triangulo") return "is-triangulo";
  if (icon === "cuadrado") return "is-cuadrado";
  return "is-circulo"; // default
};

const Legend = ({
  activeTab,
  selectedPairs,
  togglePair,
  isOpen = true,
  onToggle,
}) => {
  // Helper para envolver el contenido en el wrapper colapsable + clip + handle.
  // Espejo del FilterPanel pero colapsando hacia la derecha.
  const wrap = (clipContent) => (
    <aside className={`px-legend-rich ${isOpen ? "" : "is-collapsed"}`}>
      <div className="px-legend-clip">{clipContent}</div>
      <button
        type="button"
        className="px-legend-handle"
        onClick={onToggle}
        title={isOpen ? "Ocultar leyenda" : "Mostrar leyenda"}
      >
        <ChevronRightIcon style={{ fontSize: 18 }} />
      </button>
    </aside>
  );

  // Tab 0 (Mercados): leyenda interactiva — clic en cada modalidad togglea su par.
  if (activeTab === 0) {
    const allPairsCount =
      selectedPairs && typeof selectedPairs.size === "number"
        ? selectedPairs.size
        : 0;

    return wrap(
      <>
        <div className="px-legend-rich-head">
          <LayersIcon style={{ fontSize: 14 }} />
          <h3>Modalidades</h3>
        </div>
        <div className="px-legend-rich-body">
          {Object.entries(COLORS_MERCADOS).map(([estadoId, estado]) => (
            <div key={estadoId} className="px-legend-rich-item">
              <div className="px-legend-rich-estado">{estado.name}</div>
              <div className="px-legend-rich-mods">
                {Object.entries(estado.modalidades || {}).map(
                  ([modId, mod]) => {
                    const pairKey = `${estadoId}-${modId}`;
                    const active = selectedPairs
                      ? selectedPairs.has(pairKey)
                      : true;
                    return (
                      <button
                        key={pairKey}
                        type="button"
                        className={`px-legend-mod ${active ? "is-active" : "is-inactive"}`}
                        onClick={() => togglePair && togglePair(pairKey)}
                        title={
                          active
                            ? `Ocultar ${mod.name}`
                            : `Mostrar ${mod.name}`
                        }
                      >
                        <span
                          className="px-legend-mod-dot"
                          style={{ background: mod.color }}
                        />
                        <span className="px-legend-mod-label">{mod.name}</span>
                        {active ? (
                          <span className="px-legend-mod-check" aria-hidden>
                            ✓
                          </span>
                        ) : null}
                      </button>
                    );
                  }
                )}
              </div>
            </div>
          ))}
        </div>
        {allPairsCount === 0 && (
          <div className="px-legend-rich-empty">
            Todos los markers están ocultos. Activa alguna modalidad.
          </div>
        )}
      </>
    );
  }

  // Tabs 2 y 3 — leyenda informativa (no interactiva)
  const getLegendItems = (activeTab) => {
    switch (activeTab) {
      case 1:
        return [
          {
            type: "point",
            icon: mercados_mayoristas,
            label: "Mercados Mayoristas",
            color: "#2e7d32",
          },
        ];
      case 2:
        return [
          {
            type: "polygon",
            label: "Parques Industriales",
            color: "#5e014eff",
            subLegends: [
              {
                title: "Uso",
                items: [
                  { label: COLORS_LOTES_PARQUES[14].name, color: COLORS_LOTES_PARQUES[14].fillColor, icon: COLORS_LOTES_PARQUES[14].icon },
                  { label: COLORS_LOTES_PARQUES[15].name, color: COLORS_LOTES_PARQUES[15].fillColor, icon: COLORS_LOTES_PARQUES[15].icon },
                  { label: COLORS_LOTES_PARQUES[16].name, color: COLORS_LOTES_PARQUES[16].fillColor, icon: COLORS_LOTES_PARQUES[16].icon },
                  { label: COLORS_LOTES_PARQUES[23].name, color: COLORS_LOTES_PARQUES[23].fillColor, icon: COLORS_LOTES_PARQUES[23].icon },
                  { label: COLORS_LOTES_PARQUES[18].name, color: COLORS_LOTES_PARQUES[18].fillColor, icon: COLORS_LOTES_PARQUES[18].icon },
                  { label: COLORS_LOTES_PARQUES[19].name, color: COLORS_LOTES_PARQUES[19].fillColor, icon: COLORS_LOTES_PARQUES[19].icon },
                  { label: COLORS_LOTES_PARQUES[17].name, color: COLORS_LOTES_PARQUES[17].fillColor, icon: COLORS_LOTES_PARQUES[17].icon },
                  { label: COLORS_LOTES_PARQUES[22].name, color: COLORS_LOTES_PARQUES[22].fillColor, icon: COLORS_LOTES_PARQUES[22].icon },
                  { label: COLORS_LOTES_PARQUES[20].name, color: COLORS_LOTES_PARQUES[20].fillColor, icon: COLORS_LOTES_PARQUES[20].icon },
                  { label: COLORS_LOTES_PARQUES[21].name, color: COLORS_LOTES_PARQUES[21].fillColor, icon: COLORS_LOTES_PARQUES[21].icon },
                  { label: COLORS_LOTES_PARQUES[27].name, color: COLORS_LOTES_PARQUES[27].fillColor, icon: COLORS_LOTES_PARQUES[27].icon },
                  { label: "Disponible", color: "#fff", icon: "circulo" },
                ],
              },
            ],
          },
          {
            type: "polygon",
            label: "Zonas Económicas Especiales",
            color: "#00d9ffff",
          },
        ];
      case 3:
        return [
          {
            type: "polygon",
            label: "Zonas Industriales",
            color: "#a12323ff",
            subLegends: [
              {
                title: "Zonificación",
                items: [
                  { label: COLORS_ZONIFICACION[1].name, color: COLORS_ZONIFICACION[1].fillColor },
                  { label: COLORS_ZONIFICACION[2].name, color: COLORS_ZONIFICACION[2].fillColor },
                  { label: COLORS_ZONIFICACION[3].name, color: COLORS_ZONIFICACION[3].fillColor },
                  { label: COLORS_ZONIFICACION[4].name, color: COLORS_ZONIFICACION[4].fillColor },
                ],
              },
              {
                title: "Uso",
                items: [
                  { label: COLORS_LOTES[1].name, color: COLORS_LOTES[1].fillColor },
                  { label: COLORS_LOTES[2].name, color: COLORS_LOTES[2].fillColor },
                  { label: COLORS_LOTES[3].name, color: COLORS_LOTES[3].fillColor },
                  { label: COLORS_LOTES[4].name, color: COLORS_LOTES[4].fillColor },
                  { label: COLORS_LOTES[5].name, color: COLORS_LOTES[5].fillColor },
                  { label: COLORS_LOTES[6].name, color: COLORS_LOTES[6].fillColor },
                  { label: COLORS_LOTES[7].name, color: COLORS_LOTES[7].fillColor },
                  { label: COLORS_LOTES[8].name, color: COLORS_LOTES[8].fillColor },
                  { label: COLORS_LOTES[9].name, color: COLORS_LOTES[9].fillColor },
                  { label: COLORS_LOTES[10].name, color: COLORS_LOTES[10].fillColor },
                  { label: COLORS_LOTES[11].name, color: COLORS_LOTES[11].fillColor },
                  { label: COLORS_LOTES[12].name, color: COLORS_LOTES[12].fillColor },
                ],
              },
            ],
          },
        ];
      default:
        return [];
    }
  };

  const legendItems = getLegendItems(activeTab);
  if (!legendItems || legendItems.length === 0) return null;

  // Tabs 2/3 — leyenda informativa con el mismo look que Mercados:
  // section header por capa + filas tipo "mod" (dot + label) para cada item.
  return wrap(
    <>
      <div className="px-legend-rich-head">
        <LayersIcon style={{ fontSize: 14 }} />
        <h3>Leyenda</h3>
      </div>
      <div className="px-legend-rich-body">
        {legendItems.map((item, idx) => (
          <div key={idx} className="px-legend-rich-item">
            <div className="px-legend-rich-estado">
              <span
                className="px-legend-estado-swatch"
                style={{ background: item.color }}
              >
                {item.type === "point" && item.icon && (
                  <img src={item.icon} alt="" />
                )}
              </span>
              {toTitleCase(item.label)}
            </div>

            {item.subLegends &&
              item.subLegends.map((sub, si) => (
                <div key={si} className="px-legend-rich-mods">
                  {sub.title && (
                    <h4 className="px-legend-sub-title">{sub.title}</h4>
                  )}
                  {sub.items.map((subItem, ii) => (
                    <div key={ii} className="px-legend-mod is-static">
                      <span
                        className={`px-legend-mod-dot ${shapeClass(
                          subItem.icon
                        )}`}
                        style={{ background: subItem.color }}
                      />
                      <span className="px-legend-mod-label">
                        {toTitleCase(subItem.label)}
                      </span>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default Legend;
